
export type COOKIE_SET = "cookie-set";
export type COOKIE_GET = "cookie-get";
export type COOKIE_DELETE_ALL = "cookie-delete-all";

export type APIFunctionName = 
  COOKIE_SET |
  COOKIE_GET |
  COOKIE_DELETE_ALL
;

export class APIFunctionNames
{
  static readonly COOKIE_SET:COOKIE_SET = "cookie-set";
  static readonly COOKIE_GET:COOKIE_GET = "cookie-get";
  static readonly COOKIE_DELETE_ALL:COOKIE_DELETE_ALL = "cookie-delete-all";
}
